import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { Dns, PieChart, Bookmarks, QuestionAnswer, Assistant } from "@material-ui/icons";
import { useHistory } from "react-router-dom";

export default function MenuItems() {
  let history = useHistory();
  const navigate = (route) => history.push(route);
  return (
    <List>
      <ListItem button onClick={() => navigate("/admin/dashboard")}>
        <ListItemIcon>
          <PieChart />
        </ListItemIcon>
        <ListItemText primary="Resultados" />
      </ListItem>
      <ListItem button onClick={() => navigate("/admin/areas")}>
        <ListItemIcon>
          <Dns />
        </ListItemIcon>
        <ListItemText primary="Areas" />
      </ListItem>
      <ListItem button onClick={() => navigate("/admin/charges")}>
        <ListItemIcon>
          <Assistant />
        </ListItemIcon>
        <ListItemText primary="Cargos" />
      </ListItem>
      <ListItem button onClick={() => navigate("/admin/competences")}>
        <ListItemIcon>
          <Bookmarks />
        </ListItemIcon>
        <ListItemText primary="Competencias" />
      </ListItem>
      <ListItem button onClick={() => navigate("/admin/questions")}>
        <ListItemIcon>
          <QuestionAnswer />
        </ListItemIcon>
        <ListItemText primary="Preguntas" />
      </ListItem>
    </List>
  );
}
